/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Being_PackedInputs */

const en_shop_being_packed = /** @type {(inputs: Shop_Being_PackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being packed`)
};

const pl_shop_being_packed = /** @type {(inputs: Shop_Being_PackedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W przygotowaniu`)
};

/**
* | output |
* | --- |
* | "Being packed" |
*
* @param {Shop_Being_PackedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_being_packed = /** @type {((inputs?: Shop_Being_PackedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Being_PackedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_being_packed(inputs)
	return en_shop_being_packed(inputs)
});